import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "作品推荐", to: "/recommendations" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

const categories = ["TV动画", "剧场版", "漫画新闻", "动画电影", "作品解读"];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100 mt-auto">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">78动漫</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              78动漫专注于为动漫爱好者提供最新动漫资讯、动画作品推荐及动漫解读内容，帮助你高效发现优质作品、追踪行业动态。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-200">
                <i className="ri-weibo-fill text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-200">
                <i className="ri-bilibili-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-200">
                <i className="ri-wechat-line text-lg" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">内容分类</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {categories.map((item) => (
                <span
                  key={item}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200"
                >
                  {item}
                </span>
              ))}
            </div>
            <p className="mt-5 text-sm text-background-300">
              联系方式：
              <a
                href="mailto:hello@78anime.demo"
                className="text-accent-400 hover:text-accent-300 cursor-pointer"
              >
                hello@78anime.demo
              </a>
            </p>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-7xl flex-col items-start gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-400">
            © 2026 78动漫 · 本站内容与图片均为虚构示范，仅用于产品演示，与任何真实作品无关。
          </p>
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <span className="mr-1 inline-flex align-middle">
              <i className="ri-arrow-left-line" />
            </span>
            返回首页
          </Link>
        </div>
      </div>
    </footer>
  );
}